import { SignIn } from "@clerk/clerk-react";
import { createFileRoute } from "@tanstack/react-router";
import { StartPageShell } from "~/components/app-shell/start-page-shell";

export const Route = createFileRoute("/(auth)/sign-in")({
  component: SignInPage,
  head: () => ({
    meta: [
      {
        title: "Sign In",
      },
    ],
  }),
});

function SignInPage() {
  return (
    <StartPageShell>
      <StartPageShell.MainContent>
        {/* <SignIn withSignUp={true} transferable={true} /> */}
        <SignIn withSignUp={false} transferable={false} />
      </StartPageShell.MainContent>
    </StartPageShell>
  );
}
